import { useEffect } from "react";
import i18n, { projectLanguageToLng } from ".";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";

// The UI locale follows the current user's preference only. The open project drives just the
// document's `lang`: without it the browser picks CJK glyphs by its own locale, and Japanese
// generated content renders with Chinese character forms.
let openProjectLng: string | null = null;

const syncDocumentLang = () => {
  document.documentElement.lang = openProjectLng ?? i18n.language;
};

export function useProjectLanguageSync(projectLanguage?: string | null) {
  useEffect(() => {
    openProjectLng = projectLanguageToLng(projectLanguage);
    syncDocumentLang();
  }, [projectLanguage]);

  useEffect(() => {
    return () => {
      openProjectLng = null;
      syncDocumentLang();
    };
  }, []);
}

export function useUserLanguageSync() {
  const { uiLanguage } = useMeStore();

  useEffect(() => {
    const lng = projectLanguageToLng(uiLanguage);
    if (i18n.language !== lng) void i18n.changeLanguage(lng);
    syncDocumentLang();
  }, [uiLanguage]);
}
